import { CalculationRequestDto } from '../CalculationRequestDto';
import { IBANDto } from './IBANDto';
import { InsuranceDto } from './InsuranceDto';
import { CalculationResponseResultPremiumDto } from '../calculation/CalculationResponseResultPremiumDto';
import { IntermediaryDto } from '../IntermediaryDto';
import { InsuredDetails } from './InsuredDetails';

export class ApplicationGGDto {
  averageYearIncome: number;
  monthlyExpenses: number;
  intermediary = new IntermediaryDto();
  insured1Premium: number;
  dateOfCommencement: Date;
  calculationResponse: CalculationResponseResultPremiumDto;
  beneficiaries = null;
  bankAccount = new IBANDto();
  calculationRequest: CalculationRequestDto;
  deductPremiumFromTaxes: boolean;
  insurances: InsuranceDto[];
  insuranceSomewhereElse: boolean;
  insured1 = new InsuredDetails();
  insured2 = null;
  mortgageRelated = false;
  pledge = null;
  pledged = false;
  policyHolder1 = null;
  policyHolder2 = null;
  policyHolder2SameAsInsured2 = false;
  premiumPayer = null;
  premiumSplit = true;
  punitiveMeasures: boolean;
  punitiveMeasuresText: string;
  standardBeneficiary = true;
}
